export function createNoParamLink(apiPathElement: string) {
    return () => apiPathElement;
}
